import { useSelector } from "react-redux";
import { getMemberCount } from "../../members";
export default function MemberCount({ groupId }) {
    const member_count = useSelector((state) => getMemberCount(state));
    return member_count;
}
